import React from 'react';
import PropTypes from 'prop-types';

import { JsonLd } from 'react-schemaorg';

const generateFAQEntity = (faqEntities) => (
  faqEntities.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  }))
);

const FaqSchema = ({ faqEntities }) => (
  <JsonLd
    item={{
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: generateFAQEntity(faqEntities),
    }}
  />
);

FaqSchema.propTypes = {
  faqEntities: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    }),
  ).isRequired,
};

export default FaqSchema;
